module.exports = __webpack_public_path__ + "static/12-lathe-ebebcd7267ba41ad27beea0913a8c4b8.jpg";